import React from 'react';
import { defaultTheme } from '../../Themes/Default';

type ProgressBarProps = {
  completed: number;
  height?: number;
  color?: string;
};
const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({
  completed,
  color = defaultTheme.UI_COLORS.primary,
  height = 5,
}): React.ReactElement => {
  const containerStyles = {
    height: height,
    width: '100%',
  };

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: color,
    borderRadius: 'inherit',
    transition: 'width 0.5s',
  };

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;
